import { z } from 'zod';
import { SEASONS } from './constants.js';
export const hexCoordSchema = z.object({ q: z.number().int(), r: z.number().int() });
export const seasonConfigSchema = z.object({
    season: z.enum(SEASONS),
    prodMult: z.number().nonnegative(),
    combatMult: z.number().positive(),
    speedMult: z.number().positive(),
    colonizeLossMult: z.number().positive(),
    broodEnabled: z.boolean(),
    defenderBonus: z.number().nonnegative().default(0),
    winterDecayPct: z.number().nonnegative().default(0),
});
export const worldConfigSchema = z.object({
    speed: z.number().positive(),
    startedAt: z.coerce.date(),
    seasonLengthHours: z.number().int().positive(),
    seasonOrder: z.array(z.enum(SEASONS)).min(1),
    seasonsRepeat: z.boolean().default(true),
    protectionHours: z.number().int().nonnegative(),
    fieldDwellMinutes: z.number().int().positive(),
    fieldSlots: z.number().int().positive(),
});
export const healthSchema = z.object({
    status: z.literal('ok'),
    version: z.string(),
    uptimeSeconds: z.number(),
});
/** Diplomatie-Schnappschuss eines Zugs beim Abflug (Konzept: verhindert Statuswechsel im Flug). */
export const frozenRelationsSchema = z.object({
    allianceId: z.number().int().nullable(),
    /** effektive Beziehung zu jedem anderen Stand zum Abflugzeitpunkt */
    stances: z.record(z.string(), z.enum(['ALLIED', 'NEUTRAL', 'HOSTILE'])),
});
/** Web-Push-Inhalt, den ein Server-Event mitfuehren kann (Deep Link relativ zur App). */
export const pushPayloadSchema = z.object({
    title: z.string().min(1).max(80),
    body: z.string().max(200),
    url: z.string().max(200),
    /** gleiche Tags ersetzen sich in der Benachrichtigungsleiste */
    tag: z.string().max(60).optional(),
});
//# sourceMappingURL=schemas.js.map